import {useQuery} from "@tanstack/react-query";
import * as demandApi from "../services/demand.api";

export const useSearchDemands = (docNo) =>
	useQuery({
		queryKey: ["demands", "search", docNo],
		queryFn: () => demandApi.searchDemandsWithDocNo(docNo),
		enabled: !!docNo,
	});

export const useDemandFurnitures = (id) =>
	useQuery({
		queryKey: ["demands", id, "furnitures"],
		queryFn: () => demandApi.getDemandFurnitures(id),
		enabled: !!id,
	});
